/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { QuillDeltaHTML } from "cms/rich-text/quill-delta-html";
import { isRichTextEmptyQuill } from "cms/rich-text/richtext-utils";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";

const RichTextQuillComponentDisplay = () => {

    const { component, hide } = useContext(ContentZoneContext);
    const { richtext } = component || {};
    // const hasContent = !isRichTextEmpty(richtext)
    const hasContent = !isRichTextEmptyQuill(richtext);
    const delta = richtext;

    return (
        <>
            {!hide &&
                <>
                    <EmptyContentMessage
                        hasContent={hasContent}
                        component={component}
                    />

                    {hasContent &&
                        <QuillDeltaHTML delta={delta} />
                    }
                </>
            }
        </>
    );
};

RichTextQuillComponentDisplay.displayName = "RichTextQuillComponentDisplay";
export { RichTextQuillComponentDisplay };
